import Link from '@components/ui/link';
import {useAuthContext} from "@contexts/use-auth-context";

interface Props {
  href: string;
  btnProps: React.ButtonHTMLAttributes<any>;
}

export default function AuthMenu({
  href,
  btnProps,
  children,
}: React.PropsWithChildren<Props>) {
  const {isAuthenticated} = useAuthContext()

  return isAuthenticated ? (
    <Link
      to={href}
      className="text-sm font-normal lg:text-15px text-brand-dark focus:outline-none ltr:ml-2 rtl:mr-2"
    >
      {children}
    </Link>
  ) : (
    <button
      className="text-sm font-normal lg:text-15px text-brand-dark focus:outline-none ltr:ml-2 rtl:mr-2"
      aria-label="Authentication"
      {...btnProps}
    />
  );
}
